import { render, staticRenderFns } from "./content-item-rating.vue?vue&type=template&id=115d6494"
import script from "./content-item-rating.vue?vue&type=script&lang=js"
export * from "./content-item-rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports